import Route from '@ember/routing/route';
import { ADMIN_CONTENT_SEARCH } from 'sh-www/constants/routes/admin/content-search';

const { FILTERS_PROPERTY_NAMES } = ADMIN_CONTENT_SEARCH;

class AdminContentRoute extends Route {
  get queryParams() {
    return FILTERS_PROPERTY_NAMES.reduce((object, filter) => {
      object[filter] = { refreshModel: true };
      return object;
    }, { page: { refreshModel: true } });
  }

  /** @inheritDoc */
  model() {
    return {
      projectDigests: null,
    };
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    controller.loadCountries.perform();
    controller.loadServices.perform();
    controller.loadVideoCategories.perform();
    controller.loadClassifications.perform();
    controller.loadProjectDigests.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadCountries.cancelAll();
      controller.loadServices.cancelAll();
      controller.loadVideoCategories.cancelAll();
      controller.loadClassifications.cancelAll();
      controller.loadProjectDigests.cancelAll();
    }
  }
}

export default AdminContentRoute;
